import request from 'sb-request'
import links from 'common/helpers/links'
import { reducers, getState } from 'redux/core'
import { shippingForm } from 'pages/paymentNew/SubscribePage/util/forms'
import { object, constants, getAbValue } from 'common/helpers'
import { getCookieValue, getFeatureToggle } from 'helpers'
import { getBillData as getSubscribePageBillData } from 'pages/paymentNew/SubscribePage/util/bill'
import { getBillData as getRedeemQueuePageBillData } from 'pages/paymentNew/RedeemQueuePage/util/bill'
import { getBillData as getRedeemTossInPageBillData } from 'pages/paymentNew/RedeemTossInPage/util/bill'


const getAddressFieldValues = () => {
  const fieldNames = [ 'street', 'zipCode', 'state', 'city' ]
  const result = {}

  fieldNames.forEach((fieldName) => {
    result[fieldName] = shippingForm.fields[fieldName].value
  })

  return result
}

const checkIsPriceTestEnabled = (couponCode) => {
  const referrerLandingPageURL  = getCookieValue(constants.cookieNames.referrerLandingPageURL) || ''
  const specialFlowName         = getCookieValue(constants.cookieNames.specialFlowName)
  const referrer                = referrerLandingPageURL.replace(/.+\.(com|co|net|org)\//, '/')

  return (
    [ '/', '/men' ].includes(referrer)
    && specialFlowName === constants.specialFlowNames.facebook
    && couponCode === constants.discountCoupons['25_off']
  )
}

const getSubscriptionPriceValue = ({ price, couponCode }) => {
  const isPriceTestEnabled = checkIsPriceTestEnabled(couponCode)

  if (isPriceTestEnabled) {
    return ({
      a: price,
      b: 1695,
      c: 1795,
    })[getAbValue(constants.abTests.priceTestMobile)]
  }

  return price
}

const getTotalPriceValue = ({ price, couponCode }) => {
  const isPriceTestEnabled = checkIsPriceTestEnabled(couponCode)

  if (isPriceTestEnabled) {
    return ({
      a: price,
      b: 1271,
      c: 1346,
    })[getAbValue(constants.abTests.priceTestMobile)]
  }

  return price
}

const inquireSubscription = (values) => {
  const { offer, coupon, subscriptionCase, couponCode, couponType = 'order', plan } = values
  const { view: { pickPage: { selectedItems = [] }, paymentPageNew: { bill: { items } } } } = getState()

  if (items.length) {
    reducers.view.paymentPageNew.removeBillItems()
  }

  const isPremiumProductsForNotSubscribedEnabled = getFeatureToggle(constants.features.premiumProductsForNotSubscribed)

  const query = {
    ...getAddressFieldValues(),
    subscriptionCase,
    plan,
  }

  if (isPremiumProductsForNotSubscribedEnabled && selectedItems.length) {
    query.pickedProducts = selectedItems.map(({ id }) => id).join()
  }

  if (offer) {
    query.offer = offer
  }

  if (coupon && coupon.id) {
    query.coupon = coupon.id
  }

  if (couponCode) {
    query.couponCode = couponCode
  }

  if (couponType) {
    query.couponType = couponType
  }

  // TODO remove getSubscriptionPriceValue and getTotalPriceValue after abTest priceTestMobile will be finished
  return request.get('rest/subscription/inquire', {
    query,
    multiple: false,
    modifyResult: (response) => {
      const {
        subscription, cart, discount, tax, price, upchargePrice,
        coupon: couponCode, discountCode, offer, pickedProducts,
        subscriptionCasePrice,
      } = response

      return {
        subscription: {
          ...object.removeKeys(subscription, 'tax'),
          price: getSubscriptionPriceValue({ price: subscription.price, couponCode }),
        },
        cart: cart || {},
        bill: {
          price: getTotalPriceValue({ price, couponCode }),
          upchargePrice,
          discount,
          offer,
          tax,
        },
        coupon: {
          isFetching: false,
          code: couponCode,
          errors: discountCode && discountCode.errors ? discountCode.errors : null,
        },
        pickedProducts,
        subscriptionCasePrice,
      }
    },
  })
}

const {
  setInquireFetchingStatus, setOutOfStockProducts,
  setIsShippingValid, setPaymentMethod } = reducers.view.paymentPageNew

const setInquireAndBillData     = ({ gender, selectedPlan, inquireData }) => {
  const { routing: { location: { pathname } } } = getState()

  const isTossInCartSubtotalEnabled = getFeatureToggle(constants.features.tossInCartSubtotal)

  const getBillData = ({
    '/subscribe2': getSubscribePageBillData,
    [links.subscribe]: getSubscribePageBillData,
    [links.queueRedeem]: getRedeemQueuePageBillData,
    [links.tossInRedeem]: getRedeemTossInPageBillData,
  })[pathname]

  if (getBillData) {
    const bill = getBillData({ ...inquireData, gender, selectedPlan, isTossInCartSubtotalEnabled })

    reducers.view.paymentPageNew.setInquireAndBillData({ bill, inquireData })
  }
}


export default {
  inquireSubscription,
  setInquireFetchingStatus,
  setInquireAndBillData,
  setOutOfStockProducts,
  setIsShippingValid,
  setPaymentMethod,
}
